import React from 'react'
import FixedView from '../../components/FixedView'
import { checkTranslation, translate } from '../../utils/useful'

export default class MultiStage extends React.Component {
    state = {
        currentAction: {}
    }
    setCurrentAction = (item) => {
        this.setState({ currentAction: item })
    }
    render() {
        let name = checkTranslation(this.props.data?.name)
        let isPlaceholder = false
        if (!this.props.data?.name || this.props.data?.name == '') {
            name = "Enter name"
            isPlaceholder = true
        }
        return (
            <>
                <div className='flexcb py-1 w-100' style={{ minHeight: 36 }} >

                    <div className='w-100 pld-2 prd-2'>
                        <p className={'mrd-2 pld-2 text-small text-semibold   flex-1 w-100  '} style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{name}</p>
                        <p className={'mrd-2 pld-2 text-smallest   flex-1 w-100 opacity-5 '} style={{ whiteSpace: 'nowrap', overflow: 'hidden', }}>Click to edit</p>
                    </div>

                </div>
                <FixedView ref={(el) => (this.sortView = el)} nodeRef={this.currentNode} showFocus={false} zIndex={1} topOffset={-35} xOffset={-40}>
                    <div className='br-10 p-1 shadow-3' style={{ backgroundColor: "#fff", width: "100px" }}>
                        {this.props.actionList?.map((prop, propIndex) => {
                            return (
                                <button key={propIndex} className='flexc box-hover p-1 br-5 w-100' onClick={() => { this.props.addActions(prop.key, this.props.index); this.setCurrentAction(prop) }}>
                                    <img width={24} src={prop.icon} />
                                    <p className='py-2 mld-3' style={{ color: "#555" }} >{checkTranslation(prop.label)}</p>
                                </button>
                            )
                        })}
                    </div>
                </FixedView>
            </>
        )
    }
}